import React, { useEffect, useState } from 'react'
import styles from '../index.module.scss'
import { getStorageInfo } from '@/utils/auth'
import dayjs from 'dayjs'
import buriedSdk from '@/utils/zz-buried/index'
import { getPayDiscountInfo } from '@/service'
import { getDeviceId } from '@/utils/auth'
import TimeDown from '@/components/homeV3/pc/banner/Activity/TimeDown'
import { useWidth } from '@/utils/resize'

export default function GiftBagsDialog() {
  const { width, display } = useWidth() //服务端

  const userId = getStorageInfo()?.userId
  const caKey = `discount-visible-en-${getStorageInfo()?.userId}` // 该用户今日是否已经弹出
  const nowDate = dayjs(new Date()).format('YYYY-MM-DD')
  const [timeDownVisible, setTimeDownVisible] = useState(true)

  const [dlologVisible, setDlologVisible] = useState(false) // 领取弹框
  const [data, setData] = useState<any>({})

  useEffect(() => {
    setTimeDownVisible(!!data.usable)
  }, [data, data.usable])

  //倒计时结束
  const onTimeDownEnd = () => {
    setTimeDownVisible(false)
  }

  const handleDialogClose = () => {
    setDlologVisible(false)
    localStorage.setItem(caKey, nowDate)
  }

  const getPayDiscountData = () => {
    if (!getStorageInfo()?.userId) return // 未登录无需弹出
    const currentKey = localStorage.getItem(caKey)
    if (currentKey && currentKey === nowDate) return
    getPayDiscountInfo(14, 6, getDeviceId()).then((res) => {
      if (res.code === 0) {
        if (res?.data && res?.data?.length) {
          const info = res.data.sort((a, b) => {
            return a.actualAmount - b.actualAmount
          })[0]
          setData(info)

          if (!currentKey) {
            setDlologVisible(true)
            console.log('info~~~', info)

            buriedSdk?.buried({
              event: '显示领会员弹窗',
              scene: `满足领会员条件的用户`,
              page_name: '首页',
              page_url: document?.URL,
              user_id: getStorageInfo()?.userId,
              json_str: JSON.stringify({
                marketing_id: info?.marketingId
              }),
              URL: process.env.NEXT_PUBLIC_USER_API_DOMAIN
            })
          }
        }
      } else {
        if (currentKey && currentKey !== nowDate) {
          localStorage.removeItem(caKey)
        }
      }
    })
  }
  const handleClaim = () => {
    const mobileUrl = process.env.mobileUrl
    const pcUrl = process.env.portalUrl
    const userInfo = sessionStorage.getItem('authorized-token')

    buriedSdk.buried({
      event: `按钮点击`,
      scene: `定价升级活动入口-弹窗`,
      URL: process.env.publicApiDomain,
      json_str: JSON.stringify({
        marketing_id: data?.marketingId,
        group_num: data?.groupNum
      }),
      user_id: JSON.parse(userInfo || '{}')?.userId
    })
    handleDialogClose()
    setTimeout(() => {
      window.open(
        width > 1024 ? pcUrl + '/activity/list' : mobileUrl + '/newUserActivity',
        '_blank'
      )
    }, 500)
  }
  useEffect(() => {
    getPayDiscountData()
    return () => {
      setDlologVisible(false)
    }
  }, [])

  return dlologVisible ? (
    <div className={`${styles['gift-dialog']}`}>
      <div className={`${styles['gift-dialog-container']}`}>
        <div className={styles['bg']} onClick={handleClaim}></div>
        <div
          className={`${styles['close']} flex items-center justify-center`}
          onClick={handleDialogClose}
        >
          <i className="iconfont icon-a-55guanbi-da" />
        </div>
        {timeDownVisible ? (
          <div className="flex justify-center mt-[24px]">
            <TimeDown type="dialog" targetDate={data.usableEndTime} onEnd={onTimeDownEnd} />
          </div>
        ) : null}
      </div>
    </div>
  ) : null
}
